module.exports = __webpack_public_path__ + "img/logo.ad1d1251.png";